import { get, put, patch, del } from '../request';
import { APP_CONFIG } from '../../config';
import {
  ProfileBenefitsUserData,
  ProfileBenefitsUserDataInput,
  ProfileBenefitType,
} from '../../@types/productBenefits';

export const getProductBenefitsPersonalData = async (): Promise<ProfileBenefitsUserData> => {
  return await get(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/benefits/my/contract/personalData`,
    'XSRF-TOKEN',
  );
};

export const updateProductBenefitsContract = async (
  benefitType: ProfileBenefitType,
  formData: ProfileBenefitsUserData,
) => {
  return await put(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/benefits/my/contract`,
    {
      benefitType,
      ...formData,
    },
    'XSRF-TOKEN',
  );
};

export const patchProductBenefitsContract = async (formData: ProfileBenefitsUserDataInput) => {
  return await patch(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/benefits/my/contract`,
    { ...formData },
    'XSRF-TOKEN',
  );
};

export const updateProductBenefitsInsurances = async (benefitType: ProfileBenefitType) => {
  return await put(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/benefits/my/contract/insurances`,
    {
      benefitType,
    },
    'XSRF-TOKEN',
  );
};

export const cancelProductBenefits = async (benefitType: ProfileBenefitType) => {
  return await del(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/benefits/my/contract/insurances/${benefitType}`,
    'XSRF-TOKEN',
  );
};
